import { gotoPromotions } from "Utils/common";

const FooterNavBar: React.FC<{loginState: Object}> = (props) => {
  const { loginState } = props
    const f = (key: string) => {
        return key
    }
  
  return (
    <div className="footNavOutWrapper">
      <div
        className="pageContentContainer footNavWrapper"
        onClick={(e: any) => {
          const id = e.target?.id || e.target.parentNode?.id;
          if (!id) return;
          if (id === "PromoCenter") {

            gotoPromotions(loginState)
            return;
            window.open(
              "https://www.thermofisher.cn/cn/zh/home/promo/campaigns.html",
              "_blank"
            );
            return;
          }
          if (id === "MemberCenter") {
            window.open("https://mapac.thermofisher.cn/membership", "_blank");
            return;
          }
          if (id === "HelpCenter") {
            window.open(
              "https://www.thermofisher.cn/cn/zh/home/support.html",
              "_blank"
            );
            return;
          }
          if (id === "Shopping") {
            window.open("https://www.thermofisher.cn/cn/zh/home/order.html", "_blank");
            return;
          }
        }}
      >
        <div className="navItem" id="PromoCenter">
          <div className="navInner">{f("促销商城")}</div>
        </div>
        <div className="navItem" id="MemberCenter">
          <div className="navInner">{f("会员中心(积分兑换)")}</div>
        </div>
        <div className="navItem" id="HelpCenter">
          <div className="navInner">{f("帮助与支持")}</div>
        </div>
        <div className="navItem" id="Shopping">
          <div className="navInner">{f("选购所有商品")}</div>
        </div>
      </div>
    </div>
  );
};

export default FooterNavBar;
